export default __webpack_public_path__ + "414eaad63f2729ceaef1c9ae699f328c.png";